var map = {
	"./size-1-fin.svg": "Qcbl",
	"./size-1.svg": "dqMk",
	"./size-2-fin.svg": "4fd0",
	"./size-2.svg": "/I89",
	"./size-3-fin.svg": "jRLy",
	"./size-3.svg": "tiy5",
	"./size-4-fin.svg": "z/kh",
	"./size-4.svg": "qK6Z",
	"./size-5-fin.svg": "a9Rj",
	"./size-5.svg": "bNxM",
	"./size-6-fin.svg": "RQL7",
	"./size-6.svg": "dpu/",
	"./size.svg": "PFOs"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KOfx";